import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'How is this different from NoFap?',
  a: "NoFap relies heavily on counting days, willpower, and restriction, which often leads to a 'binge and purge' cycle. UNHOOKED focuses on dismantling the desire itself through neuroscience. When you understand the mechanism, the days become irrelevant because you simply lose interest in the behavior."
}, {
  q: 'Do I need to quit immediately?',
  a: 'No. In fact, we encourage you to simply read the book first without forcing any behavioral changes. As you begin to understand the mechanisms of your dopamine system, the compulsion will naturally begin to fade without forced restriction.'
}, {
  q: 'Is this based on neuroscience?',
  a: 'Yes. The framework is built on modern understandings of dopamine regulation, neuroplasticity, and habit formation. However, it is translated into calm, accessible, and actionable concepts rather than dense medical jargon.'
}, {
  q: 'How quickly will I notice changes?',
  a: 'Many readers report a profound shift in perspective within the first few chapters as the shame lifts. Biological changes—like restored focus, deeper sleep, and returning baseline dopamine levels—typically become noticeable within the first 7 to 14 days.'
}, {
  q: 'Is this private?',
  a: 'Completely. Your purchase appears discreetly on your statement, and the digital files are delivered instantly to your email. There are no physical mailings or community forums you are forced to join.'
}, {
  q: 'What exactly do I receive?',
  a: 'You receive instant access to the UNHOOKED digital guide in PDF, EPUB, and MOBI formats, perfectly formatted for reading on your phone, tablet, Kindle, or computer.'
}, {
  q: 'Is this a subscription?',
  a: 'No. This is a one-time purchase for lifetime access to the guide and any future updates.'
}, {
  q: "What if this doesn't work for me?",
  a: "We offer a calm, no-questions-asked 30-day guarantee. If the framework doesn't resonate with you or help shift your perspective, simply reply to your receipt email and we will refund your purchase in full."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 bg-charcoal relative" data-id="element-66">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-67">
        <div className="text-center mb-7 sm:mb-10" data-id="element-68">
          <div className="text-gold tracking-[0.2em] uppercase text-xs sm:text-sm mb-4" data-id="element-69">
            Clarity
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl text-ivory" data-id="element-70">
            Questions
          </h2>
        </div>

        <div className="space-y-1" data-id="element-71">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-gold/10" data-id="element-72">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full py-5 sm:py-6 flex items-center justify-between text-left focus:outline-none group gap-4" data-id="element-73">
                  <span className="text-base sm:text-xl text-ivory/90 font-medium group-hover:text-gold transition-colors" data-id="element-74">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-gold/60 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-75" />
                </button>
                <div className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-76">
                  <div className="overflow-hidden" data-id="element-77">
                    <p className="pb-6 text-ivory/70 text-base sm:text-lg font-light leading-relaxed" data-id="element-78">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}